import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { LanguageDto } from '../models/languagedto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private url_language_list = '';
  private url_language_create = '';
  private url_language_update = '';
  private url_language_delete = '';

  constructor(private http: HttpClient, private configService: AppConfigService) {
    this.url_language_list = this.configService.apiUrl + "/configuration/language/listAll";
    this.url_language_create = this.configService.apiUrl + "/configuration/language/insert";
    this.url_language_update = this.configService.apiUrl + "/configuration/language/update";
    this.url_language_delete = this.configService.apiUrl + "/configuration/language/delete/";
  }



  language = new LanguageDto;

  public getAllLanguage(pageRequest: PaginationFeaturesDto): Observable<any> {
    const params = new HttpParams()
      .set('page', pageRequest.page)
      .set('sizePage', pageRequest.sizePage)
      .set('orderField', pageRequest.orderField)
      .set('order', pageRequest.order);
    return this.http.get<any>(this.url_language_list, { params });
  }

  public createLanguage(languageDto: LanguageDto): Observable<any> {
    return this.http.post<any>(this.url_language_create, languageDto);
  }

  public updateLanguage(languageDto: LanguageDto): Observable<any> {
    return this.http.put<any>(this.url_language_update, languageDto);
  }

  public deleteLanguage(idLanguage: number, isDefault: boolean): Observable<any> {
    return this.http.delete<any>(this.url_language_delete + idLanguage + "/" + isDefault);
  }

}

